import theme from '../../themes/theme';

const { appColors } = theme;
const flexDefaultProps = () => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  alignSelf: 'stretch',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
});
const showVAWrapper = process.env.REACT_APP_SHOW_VA_WRAPPER === 'yes';
const paddingForVAWrapper = () => {
  if (showVAWrapper) {
    return { paddingTop: '2.5em', paddingLeft: '6.125em', paddingRight: '1.5em' };
  }
  return { paddingTop: '0', paddingLeft: '0', paddingRight: '0' };
};

export default {
  layoutContainer: {
    ...flexDefaultProps(),
    ...paddingForVAWrapper(),
    height: '100%',
    width: '100%',
    background: appColors.background,
  },
  topBar: {
    width: '100%',
    height: '5em',
    background: 'transparent',
    boxShadow: 'none',
    color: '#333',
  },
  closeButton: {
    height: '4.25em',
    width: '4.25em',
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    color: appColors.secondaryGray,
  },
  closeIcon: {
    fontSize: '2em',
  },
  appContainer: {
    ...flexDefaultProps(),
    flex: 10,
    // border: '3px solid red',
  },
  appHeader: {
    ...flexDefaultProps(),
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: '4.625em',
    padding: '1em',
    background: appColors.contentBackground,
  },
  appContent: {
    ...flexDefaultProps(),
    flex: 12,
    marginTop: showVAWrapper ? '0.35em' : '0',
    background: appColors.contentBackground,
  },
  footer: {
    order: 0,
    flex: 1,
    alignSelf: 'stretch',
    fontSize: 'calc(10px + 2vmin)',
    color: appColors.titleText,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  bottomBar: {
    width: '100%',
    height: '50%',
    top: 'auto',
    bottom: 0,
    border: 0,
    boxShadow: 'none',
    background: appColors.bottomBar,
  },
  dateDay: {
    color: appColors.regularText,
    fontWeight: '600',
    fontSize: '1.125em',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '2em',
    textAlign: 'center',
    marginBottom: '-4.56em',
    width: '100%',
    background: appColors.dayDateBackground,
  },
};
